import { watch, watchEffect } from "vue"
import { dataSet } from "../../../../../../helpers/dot"

/**
 * Creates a watch to fill in the confirmation fields when the current answers or membership type is updated
 * 
 * @param {Object} data 
 * @param {Object} form 
 * @returns {Function} cancels the watch when executed
 */
export function createAnswerAndMembershipTypeWatch(data, form){
    return watchEffect(
        () => {
            (data.membership_type.details.value?.fields ?? [])
                .filter(field => field.confirmed)
                .forEach(
                    (field) => {
                        const savedAnswer = data.answers.details.value?.[field.id]
                        const currentAnswer = form.data.value.fields?.[field.id]

                        if(
                            Array.isArray(savedAnswer) 
                                ? equal(savedAnswer, currentAnswer) 
                                : (savedAnswer === currentAnswer)
                        ){
                            dataSet(form.data.value.fields, `${field.id}_confirmation`, savedAnswer)
                        }
                    }
                )
        }
    )
}